import React from 'react';

// BrightLabs mark (v2 — Feb 2026 rebrand).
// Renders the color BL mark as a transparent PNG with retina-friendly srcset.
// Note: className MUST supply height AND width (e.g. "h-10 w-10").
export const BrightLabsIcon = ({ className = "h-10 w-10", alt = "BrightLabs" }) => {
  return (
    <img
      src="/brand/brightlabs-mark-v2-128.png"
      srcSet="/brand/brightlabs-mark-v2-64.png 1x, /brand/brightlabs-mark-v2-128.png 2x, /brand/brightlabs-mark-v2-256.png 3x, /brand/brightlabs-mark-v2-512.png 4x"
      alt={alt}
      loading="eager"
      decoding="async"
      className={`object-contain ${className}`}
    />
  );
};

export default BrightLabsIcon;
